// import React, { useEffect, useState } from "react";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const Transactions = () => {
//   const [data, setData] = useState([]);
//   const [selectedIds, setSelectedIds] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);

//   const user = JSON.parse(localStorage.getItem("user"));

//   const fetchPendingStocks = async () => {
//     try {
//       const res = await fetch(`${process.env.REACT_APP_BASE_URL}stock/pending`, {
//         headers: {
//           Authorization: `Bearer ${user?.token}`,
//         },
//       });
//       const json = await res.json();
//       setData(json?.data || []);
//     } catch (err) {
//       console.error("Error fetching pending stocks", err);
//     }
//   };

//   useEffect(() => {
//     fetchPendingStocks();
//   }, []);

//   const exportToExcel = () => {
//     const exportData = data.map((item) => ({
//       State: `${item.statename} (${item.statecode})`,
//       "Commodity Code": item.commoditycode,
//       Scheme: item.scheme,
//       Season: item.season,
//       Year: item.year,
//       "Available Qty (PSF)": item.availableqtypsf,
//       "Age of Stock (PSF)": item.ageofstockpsf,
//       "Last Updated": new Date(item.lastUpdatedDate).toLocaleDateString(),
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Pending Stocks");

//     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
//     saveAs(blob, "Pending_Stocks.xlsx");
//   };

//   const handleSelectAll = () => {
//     if (selectAll) {
//       setSelectedIds([]);
//     } else {
//       setSelectedIds(data.map((item) => item.id));
//     }
//     setSelectAll(!selectAll);
//   };

//   const handleCheckboxChange = (id) => {
//     if (selectedIds.includes(id)) {
//       setSelectedIds((prev) => prev.filter((i) => i !== id));
//     } else {
//       setSelectedIds((prev) => [...prev, id]);
//     }
//   };

//   const handleApprove = async () => {
//     try {
//       const res = await fetch(`${process.env.REACT_APP_BASE_URL}stock/update-status`, {
//         method: "PATCH",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${user?.token}`,
//         },
//         body: JSON.stringify({
//           ids: selectedIds,
//           status: "Approved",
//         }),
//       });

//       const json = await res.json();
//       if (json.message === "Stock status updated successfully") {
//         const remaining = data.filter((item) => !selectedIds.includes(item.id));
//         setData(remaining);
//         setSelectedIds([]);
//         setSelectAll(false);
//       }
//     } catch (err) {
//       console.error("Error approving stocks", err);
//     }
//   };

//   return (
//     <div className="bg-white shadow-md rounded p-6 overflow-x-auto mt-4">
//       <div className="flex justify-between items-center mb-4">
//         <h2 className="text-2xl font-bold text-gray-800">Pending Stocks</h2>
//         <div className="flex gap-4">
//           <button
//             onClick={exportToExcel}
//             className="bg-green-600 hover:bg-green-700 text-white font-medium px-4 py-2 rounded shadow"
//           >
//             Export to Excel
//           </button>
//           <button
//             disabled={selectedIds.length === 0}
//             onClick={handleApprove}
//             className={`${
//               selectedIds.length === 0
//                 ? "bg-gray-300 cursor-not-allowed"
//                 : "bg-blue-600 hover:bg-blue-700"
//             } text-white font-medium px-4 py-2 rounded shadow`}
//           >
//             Approve Selected
//           </button>
//         </div>
//       </div>

//       <table className="min-w-full divide-y divide-gray-200 text-sm">
//         <thead className="bg-gray-100">
//           <tr>
//             <th className="px-2 py-2 text-left">
//               <input
//                 type="checkbox"
//                 checked={selectAll}
//                 onChange={handleSelectAll}
//               />
//             </th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">State</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Commodity Code</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Scheme</th>
//              <th className="px-4 py-2 text-left font-medium text-gray-600">Year</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Season</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Available Qty(QTL) (PSF)</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Age of Stock(QTL) (PSF)</th>
//             <th className="px-4 py-2 text-left font-medium text-gray-600">Last Updated</th>
//           </tr>
//         </thead>
//         <tbody className="divide-y divide-gray-100">
//           {data.map((item) => (
//             <tr key={item.id} className="hover:bg-gray-50">
//               <td className="px-2 py-2">
//                 <input
//                   type="checkbox"
//                   checked={selectedIds.includes(item.id)}
//                   onChange={() => handleCheckboxChange(item.id)}
//                 />
//               </td>
//               <td className="px-4 py-2">{item.statename} ({item.statecode})</td>
//               <td className="px-4 py-2">{item.commoditycode}</td>
//               <td className="px-4 py-2">{item.scheme}</td>
//               <td className="px-4 py-2">{item.year}</td>
//               <td className="px-4 py-2">{item.season}</td>
//               <td className="px-4 py-2">{item.availableqtypsf?.toLocaleString()}</td>
//               <td className="px-4 py-2">{item.ageofstockpsf}</td>
//               <td className="px-4 py-2">{new Date(item.lastUpdatedDate).toLocaleDateString()}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {data.length === 0 && (
//         <p className="text-center text-gray-500 py-4">No pending stocks found.</p>
//       )}
//     </div>
//   );
// };

// export default Transactions;
import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Transactions = () => {
  const [data, setData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [states, setStates] = useState([]);
  const [commodities, setCommodities] = useState([]);

  const [selectedYear, setSelectedYear] = useState("");
  const [selectedSeason, setSelectedSeason] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCommodity, setSelectedCommodity] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const buildQueryParams = () => {
    const params = new URLSearchParams();
    if (selectedYear) params.append("year", selectedYear);
    if (selectedSeason) params.append("season", selectedSeason);
    if (selectedCommodity) params.append("commoditycode", selectedCommodity);
    if (selectedState) params.append("state", selectedState);
    return params.toString();
  };

  const fetchPendingStocks = async () => {
    try {
      const queryParams = buildQueryParams();
      const res = await fetch(`${baseUrl}stock/pending?${queryParams}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
      const json = await res.json();
      setData(json?.data || []);
      setSelectedIds([]);
      setSelectAll(false);
    } catch (err) {
      console.error("Error fetching pending stocks", err);
    }
  };

  const fetchFilters = async () => {
    try {
      const [yearRes, seasonRes, stateRes, commodityRes] = await Promise.all([
        fetch(`${baseUrl}common/years`, { headers: { Authorization: `Bearer ${user?.token}` } }),
        fetch(`${baseUrl}common/seasons`, { headers: { Authorization: `Bearer ${user?.token}` } }),
        fetch(`${baseUrl}common/states`, { headers: { Authorization: `Bearer ${user?.token}` } }),
        fetch(`${baseUrl}commodity`, { headers: { Authorization: `Bearer ${user?.token}` } }),
      ]);

      const yearsData = await yearRes.json();
      const seasonData = await seasonRes.json();
      const stateData = await stateRes.json();
      const commodityData = await commodityRes.json();

      setYears(Array.isArray(yearsData) ? yearsData : []);
      setSeasons(Array.isArray(seasonData) ? seasonData.map(s => ({
        key: s.key,
        value: s.value.toLowerCase().charAt(0).toUpperCase() + s.value.slice(1).toLowerCase(),
      })) : []);
      setStates(Array.isArray(stateData) ? stateData : []);
      setCommodities(Array.isArray(commodityData) ? commodityData : []);
    } catch (err) {
      console.error("Error fetching filters", err);
    }
  };

  useEffect(() => {
    fetchFilters();
  }, []);

  useEffect(() => {
    fetchPendingStocks();
  }, [selectedYear, selectedSeason, selectedState, selectedCommodity]);

  const exportToExcel = () => {
    const exportData = data.map((item) => ({
      State: `${item.statename} (${item.statecode})`,
      "Commodity Code": item.commoditycode,
      Scheme: item.scheme,
      Season: item.season,
      Year: item.year,
      "Available Qty (PSF)": item.availableqtypsf,
      "Age of Stock (PSF)": item.ageofstockpsf,
      "Last Updated": new Date(item.lastUpdatedDate).toLocaleDateString(),
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Pending Stocks");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Pending_Stocks.xlsx");
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedIds([]);
    } else {
      setSelectedIds(data.map((item) => item.id));
    }
    setSelectAll(!selectAll);
  };

  const handleCheckboxChange = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds((prev) => prev.filter((i) => i !== id));
    } else {
      setSelectedIds((prev) => [...prev, id]);
    }
  };

  const handleApprove = async () => {
    try {
      const res = await fetch(`${baseUrl}stock/update-status`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify({
          ids: selectedIds,
          status: "Approved",
        }),
      });

      const json = await res.json();
      if (json.message === "Stock status updated successfully") {
        const remaining = data.filter((item) => !selectedIds.includes(item.id));
        setData(remaining);
        setSelectedIds([]);
        setSelectAll(false);
      }
    } catch (err) {
      console.error("Error approving stocks", err);
    }
  };

  return (
    <div className="bg-white shadow-md rounded p-6 overflow-x-auto mt-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-gray-800">Pending Stocks</h2>
        <div className="flex gap-4">
          <button
            onClick={exportToExcel}
            className="bg-green-600 hover:bg-green-700 text-white font-medium px-4 py-2 rounded shadow"
          >
            Export to Excel
          </button>
          <button
            disabled={selectedIds.length === 0}
            onClick={handleApprove}
            className={`${
              selectedIds.length === 0
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            } text-white font-medium px-4 py-2 rounded shadow`}
          >
            Approve Selected
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="flex flex-wrap gap-4 mb-5">
        <div>
          <label className="block text-sm font-medium text-gray-600">Year</label>
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            className="border border-gray-300 rounded px-3 py-1"
          >
            <option value="">All</option>
            {years.map(({ year }) => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-600">Season</label>
          <select
            value={selectedSeason}
            onChange={(e) => setSelectedSeason(e.target.value)}
            className="border border-gray-300 rounded px-3 py-1"
          >
            <option value="">All</option>
            {seasons.map(({ key, value }) => (
              <option key={key} value={value}>{value}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-600">Commodity</label>
          <select
            value={selectedCommodity}
            onChange={(e) => setSelectedCommodity(e.target.value)}
            className="border border-gray-300 rounded px-3 py-1"
          >
            <option value="">All</option>
            {commodities.map(({ commoditycode, commodityname }) => (
              <option key={commoditycode} value={commoditycode}>
                {commodityname}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-600">State</label>
          <select
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
            className="border border-gray-300 rounded px-3 py-1"
          >
            <option value="">All</option>
            {states.map(({ code, name }) => (
              <option key={code} value={code}>{name}</option>
            ))}
          </select>
        </div>
      </div>

      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-2 py-2 text-left">
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
              />
            </th>
            <th className="px-4 py-2 text-left font-medium text-gray-600">State</th>
            <th className="px-4 py-2 text-left font-medium text-gray-600">Commodity Name</th>
            <th className="px-4 py-2 text-left font-medium text-gray-600">Scheme</th>
            <th className="px-4 py-2 text-left font-medium text-gray-600">Year</th>
            <th className="px-4 py-2 text-left font-medium text-gray-600">Season</th>
            <th className="px-4 py-2 text-left font-medium text-gray-600">Available Qty(QTL) (PSF)</th>
            <th className="px-4 py-2 text-left font-medium text-gray-600">Age of Stock(QTL) (PSF)</th>
            <th className="px-4 py-2 text-left font-medium text-gray-600">Last Updated</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {data.map((item) => (
            <tr key={item.id} className="hover:bg-gray-50">
              <td className="px-2 py-2">
                <input
                  type="checkbox"
                  checked={selectedIds.includes(item.id)}
                  onChange={() => handleCheckboxChange(item.id)}
                />
              </td>
              <td className="px-4 py-2">{item.statename} ({item.statecode})</td>
              <td className="px-4 py-2">{item.commodityname}</td>
              <td className="px-4 py-2">{item.scheme}</td>
              <td className="px-4 py-2">{item.year}</td>
              <td className="px-4 py-2">{item.season}</td>
              <td className="px-4 py-2">{item.availableqtypsf?.toLocaleString()}</td>
              <td className="px-4 py-2">{item.ageofstockpsf}</td>
              <td className="px-4 py-2">{new Date(item.lastUpdatedDate).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {data.length === 0 && (
        <p className="text-center text-gray-500 py-4">No pending stocks found.</p>
      )}
    </div>
  );
};

export default Transactions;
